import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/css/default.css';
import flags from '../../../../../icons/flags.png';
import styles from './login.module.scss';
import { getTwoLetterCountryCode } from '../../../../../utils/helpers';

const LoginForm = (props) => {
   const {
    handleInputChange,
    handleSignIn,
    errors,
    handleInputBlurred,
    blurredFields,
    cognitoPhoneError,
    phone,
    match: { params: { installationId } }
   } = props;

   const [Location, SetLocation] = useState();
   const [isDisabled, setIsDisabled] = useState(false);

   const fetchLocation = async () => {
     const isValid = getTwoLetterCountryCode(installationId).toLowerCase();
     try {
       const position = await new Promise((resolve, reject) => {
         navigator.geolocation.getCurrentPosition(resolve, reject);
       });

       const response = await fetch(
         `https://maps.googleapis.com/maps/api/geocode/json?address=
         ${position?.coords?.latitude},
         ${position?.coords?.longitude}
         &key=${process.env.REACT_APP_GMAPS_KEY}`
       );

       const responseJson = await response.json();

       if (responseJson.status === 'OK') {
         const country = responseJson?.results[0]?.address_components?.find(
           component => component.types.includes('country')
         );
         if (isValid) {
           SetLocation(isValid);
       } else {
         // Set country or default to 'us'
         SetLocation(country ? country.short_name.toLowerCase() : 'us');
       }
       } else {
         SetLocation('us');
       }
     } catch (error) {
      if (isValid) {
        SetLocation(isValid);
      } else {
       SetLocation('us');
      }
     }
   };

   useEffect(() => {
    setIsDisabled(Location === undefined);
    fetchLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Location]);

  return (<>
    <form name="loginForm" className={styles.login_form} onSubmit={handleSignIn} noValidate>
      <div className={styles.login_form_wrapper}>
        {/* <img
          src={img}
          alt="logo"
          style={{ maxWidth: '141px', width: '140px', height: '70px', objectFit: 'cover', marginTop: '6%', marginBottom: '3%' }}
          className={styles.logo}
        /> */}
        <div className={styles.login_message} style={{ marginTop: '6%' }}>
          <FormattedMessage
            id="authentication.login.adp"
            defaultMessage="Please, authorise with your phone number"
          />
        </div>
        <p style={{ fontSize: '12px', margin: 0 }}>We’ll send a code in few mins</p>
        <div className={styles.column_wrapper}>
          <div className={styles.form_column}>
            <label htmlFor="phone" style={{ marginBottom: 0 }}>
            {Location && <ReactTelInput
                type="text"
                id="phone"
                flagsImagePath={flags}
                onChange={(e) => { handleInputChange('phone', e); }}
                onBlur={() => { handleInputBlurred('phone'); }}
                name="phone number"
                required value={phone} classNames={styles.telephoneInput}
                 defaultCountry={Location||'us'} placeholder="Phone Number"
                inputProps={{ placeholder: 'Enter Phone Number' }}
              />
            }
              <div className={styles.circle_green} />
            </label>
            {blurredFields.phone && errors.phoneEmpty ? (
              <small className={styles.error}>
                <FormattedMessage id="authentication.login.error.email_empty" defaultMessage="This field cannot be empty" />
              </small>
            ) : null}
            {blurredFields.phone && cognitoPhoneError ? (
              <small className={styles.error}>
                <FormattedMessage
                  id="authentication.login.cognito.phone_error"
                  defaultMessage="The phone number you entered is not registered in the system.
                                            Please try again with another number or contact your system administrator."
                />
              </small>
            ) : null}
            {!blurredFields.phone || (!errors.phoneEmpty && !errors.phoneInvalid) ? (
              <small className={styles.empty_error} />
            ) : null}
          </div>
        </div>
        {errors.invalidCredentials ? (
          <div className={`${styles.error} ${styles.invalid_credentials}`}>
            <FormattedMessage id="authentication.login.error.invalid_credentials" defaultMessage="Invalid Credentials" />
          </div>) : null}
        <div className={styles.button_wrapper}>
          <button
            type="submit"
            className={styles.button}
            disabled={isDisabled}
          >
            <FormattedMessage id="authentication.login.get_code" defaultMessage="Get Code" />
          </button>
        </div>
      </div>
    </form>
          </>
  );
};


LoginForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleSignIn: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  blurredFields: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  handleInputBlurred: PropTypes.func.isRequired
};

export default LoginForm;
